import { render, staticRenderFns } from "./AdultForm.vue?vue&type=template&id=71433071&scoped=true&"
import script from "./AdultForm.vue?vue&type=script&lang=js&"
export * from "./AdultForm.vue?vue&type=script&lang=js&"
import style0 from "./AdultForm.vue?vue&type=style&index=0&id=71433071&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71433071",
  null
  
)

export default component.exports